export default "__VITE_ASSET__CxItk8JB__"